<template>
  <div
    @click="$emit('select')"
    class="group cursor-pointer transition-all duration-300"
    :class="[
      // Desktop styles (md and up)
      'md:bg-white/70 md:backdrop-blur-sm md:rounded-2xl md:p-4 md:border md:hover:shadow-lg md:hover:-translate-y-1 md:flex md:items-center md:justify-between',
      'bg-transparent border-b-2 px-4 py-3 flex items-center justify-between w-full',
      // Active/inactive states
      isActive
        ? 'md:border-blue-200 md:bg-blue-50/50 md:ring-2 md:ring-blue-500/20 md:shadow-md border-b-blue-500 bg-blue-50/30'
        : 'md:border-gray-200 md:hover:border-blue-200 border-b-gray-200 hover:border-b-blue-300 hover:bg-blue-50/10',
    ]"
  >
    <!-- Left side content - icon and title -->
    <div class="flex items-center space-x-3 md:space-x-4">
      <div
        class="w-8 h-8 md:w-10 md:h-10 rounded-xl flex items-center justify-center transition-colors duration-200"
        :class="[
          isActive
            ? 'bg-blue-100 text-blue-600'
            : 'bg-gray-100 text-gray-600 group-hover:bg-blue-100 group-hover:text-blue-600',
        ]"
      >
        <component
          :is="icon"
          class="w-4 h-4 md:w-5 md:h-5"
        />
      </div>
      <div class="md:block">
        <h3
          class="text-sm md:text-md font-semibold transition-colors duration-200"
          :class="[
            isActive
              ? 'text-blue-900'
              : 'text-gray-900 group-hover:text-blue-900',
          ]"
        >
          {{ title }}
        </h3>
        <!-- Hide description on mobile, show on desktop -->
        <p
          class="hidden md:block text-sm transition-colors duration-200"
          :class="[
            isActive
              ? 'text-blue-600'
              : 'text-gray-600 group-hover:text-blue-600',
          ]"
        >
          {{ description }}
        </p>
      </div>
    </div>
    <!-- Right side indicator - now visible on mobile too for better balance -->
    <div
      class="w-3 h-3 rounded-full transition-all duration-200"
      :class="[
        isActive
          ? 'bg-blue-500 scale-100'
          : 'bg-gray-300 scale-75 group-hover:bg-blue-400 group-hover:scale-100',
      ]"
    ></div>
  </div>
</template>

<script setup>
  import { defineProps, defineEmits } from "vue";

  defineProps({
    title: String,
    description: String,
    icon: Object,
    isActive: Boolean,
  });

  defineEmits(["select"]);
</script>
